import Grid from '@mui/material/Grid2'
import Skeleton from '@mui/material/Skeleton'

export const DiskPageSkeleton = () => {
    return (
        <Grid
            m={2}
            size={{ xs: 12, sm: 12, md: 6, lg: 3 }}
            sx={{ display: 'flex', width: '100% !important' }}>
            <Skeleton
                variant="rectangular"
                sx={{
                    height: '192px',
                    width: '270px',
                    borderRadius: '24px',
                    mb: '4px',
                    mr: 2,
                }}
            />
            <Skeleton
                variant="rectangular"
                sx={{
                    height: '192px',
                    width: '270px',
                    borderRadius: '24px',
                    mb: '4px',
                    mr: 2,
                }}
            />
            <Skeleton
                variant="rectangular"
                sx={{
                    height: '192px',
                    width: '270px',
                    borderRadius: '24px',
                    mb: '4px',
                    mr: 2,
                }}
            />
            <Skeleton
                variant="rectangular"
                sx={{
                    height: '192px',
                    width: '270px',
                    borderRadius: '24px',
                    mb: '4px',
                    mr: 2,
                }}
            />
        </Grid>
    )
}
